import { Component, Input, OnInit } from '@angular/core';
import { AudienceEntity } from '../../../domain/entities/audience.entity';
import { ActivatedRoute, Router } from '@angular/router';
import { AudienceUseCase } from '../../../domain/usecases/get-audience.usecase';
import { Failure } from 'src/app/core/utils/failure';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { Toast } from 'primeng/toast';
import { UserData } from 'src/app/features/user/domain/entities/user-data.entity';
import { UserService } from 'src/app/features/user/services/user.service';
import { AudiencePagination } from '../../../domain/entities/audience-pagination.entity';
import { GetPaginationAudiencesUseCase } from '../../../domain/usecases/get-pagination-audiences.usecase';
import { AudiencePaginationParamsModel } from '../../../data/models/audience-pagination-params.model';
import { TableLazyLoadEvent } from 'primeng/table';
import { UserRol } from 'src/app/core/enums/user-rol.enum';
import { LocalStorageServiceBase } from 'src/app/core/services/localStorage-serviceBase';
import AESEncryptDecryptService from 'src/app/core/utils/crypto';
import { GetAllAudiencesByIdConciliadorPagination } from '../../../domain/usecases/getAllAudiencesByIdConciliadorPagination.usecase';
import { DeleteAudienceModel } from '../../../data/models/delete-audience.model';
import { DeleteAudienceUseCase } from '../../../domain/usecases/delete-audience.usecase';
import { ClaimUseCase } from 'src/app/features/claims/domain/usecases/get-claim.usecase';
import { ClaimEntity } from '../../../../claims/domain/entities/claim.entity';
import { AudiencesService } from '../../../services/audiences.service';
import { AudienceFilterModel } from '../../../data/models/audience-filter.model';
import { Pagination } from 'src/app/core/interfaces/pagination.interface';
import { GetAllNextAudiencesCase } from '../../../domain/usecases/get-all-next-audiences.usecase';
import { FilterServiceService } from '../../../services/filter-service.service';

@Component({
  selector: 'app-audience-table',
  templateUrl: './audience-table.component.html',
  styleUrls: ['./audience-table.component.css'],
  providers: [MessageService, Toast, ConfirmationService],
})
export class AudienceTableComponent implements OnInit {
  public pagination: Pagination = {
    totalQuantity: 0,
    numberOfPages: 0,
    itemsPerPage: 5,
    actualPage: 1,
  };

  filters?: AudienceFilterModel;

  public skeleton: boolean = true;
  public skeletons: any = [{}, {}, {}, {}, {}];

  private AES = new AESEncryptDecryptService();
  rol!: string;
  userId!: string;

  nextAudienceOfConciliator?: AudienceEntity;
  nextAudienceDate?: Date;
  isComisionMemberRol: boolean = false;
  isAdministratorRol: boolean = false;
  isConciliatorRol: boolean = false;
  isComisionRol: boolean = false;

  allAudiences: AudienceEntity[] = [];
  isLoading: boolean = true;
  homeView: boolean = false;
  haveResults: boolean = true;

  audience?: AudienceEntity;
  selectedAudience?: AudienceEntity;
  audienceId?: string;

  claim?: ClaimEntity;
  claimId?: string;
  minuteDialogVisible: boolean = false;
  isLoadingSpinner: boolean = false;
  audienciaDialogVisible: boolean = false;

  public items: MenuItem[] = [];
  public singleItem: MenuItem[] = [
    {
      label: 'Ver reclamo',
      icon: 'pi pi-eye',
      command: () => this.viewClaim(),
    },
  ];

  public threeOptionsItems: MenuItem[] = [
    {
      label: 'Link a Google Meet',
      icon: 'pi pi-video',
      command: () => this.openMeet(),
    },
    {
      label: 'Ver reclamo',
      icon: 'pi pi-eye',
      command: () => this.viewClaim(),
    },
    {
      label: 'Eliminar audiencia',
      icon: 'pi pi-trash',
      command: () => this.deleteAudience(),
    },
  ];

  constructor(
    private getPaginationAudiencesUseCase: GetPaginationAudiencesUseCase,
    private getPaginationNextAudiencesUseCase: GetAllNextAudiencesCase,
    private getAllAudiencesByIdConciliadorPagination: GetAllAudiencesByIdConciliadorPagination,
    private router: Router,
    private audienceUseCase: AudienceUseCase,
    private messageService: MessageService,
    private localStorageService: LocalStorageServiceBase,
    private confirmationService: ConfirmationService,
    private deleteAudienceUseCase: DeleteAudienceUseCase,
    private filterService: FilterServiceService
  ) { }

  ngOnInit(): void {
    this.rol = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_rol')
    );
    this.userId = this.AES.decrypt(
      this.localStorageService.loadStorageData('user_id')
    );
    this.setRol();
    this.checkHomeView();
    const savedFilters = this.filterService.getFilters();
    if (this.isConciliatorRol) {
      if (savedFilters) {
        this.filters = savedFilters;
        this.getAllAudiencesByIdConciliador();
      } else {
        this.getAllAudiencesByIdConciliador();
      }
    }
    if (
      this.isAdministratorRol ||
      this.isComisionMemberRol ||
      this.isComisionRol
    ) {
      if (savedFilters) {
        this.filters = savedFilters;
        this.getAudiencesPaginated();
      } else {
        this.getAudiencesPaginated();
      }
    }
  }

  setRol() {
    switch (this.rol) {
      case UserRol.COMISSION:
        return (this.isComisionRol = true);
      case UserRol.COMISSION_MEMBER:
        return (this.isComisionMemberRol = true);
      case UserRol.ADMINISTRATOR:
        return (this.isAdministratorRol = true);
      case UserRol.CONCILIATOR:
        return (this.isConciliatorRol = true);
      default:
        return;
    }
  }

  verificateAudienceDate(): boolean {
    if (!this.selectedAudience) return false;
    const now = new Date();
    const audienceDateTime = new Date(this.selectedAudience.date);
    if (this.selectedAudience.time) {
      const [hours, minutes] = this.selectedAudience.time
        .split(':')
        .map(Number);
      audienceDateTime.setHours(hours, minutes, 0, 0);
    }
    return now > audienceDateTime;
  }

  verificateForMeeting(): boolean {
    if (!this.selectedAudience) return false;
    const today = new Date().setHours(0, 0, 0, 0);
    const dateAudience = new Date(this.selectedAudience!.date).setHours(
      0,
      0,
      0,
      0
    );
    return dateAudience === today;
  }

  verificateAudienceDateForDelete(): boolean {
    if (!this.selectedAudience) return false;
    const today = new Date().setHours(0, 0, 0, 0);
    const dateAudience = new Date(this.selectedAudience!.date).setHours(
      0,
      0,
      0,
      0
    );
    return dateAudience > today;
  }

  buildMenuItems() {
    const items: MenuItem[] = [
      {
        label: 'Link a Google Meet',
        icon: 'pi pi-video',
        disabled: !this.verificateForMeeting(),
        command: () => this.openMeet(),
      },
      {
        label: 'Ver reclamo',
        icon: 'pi pi-eye',
        command: () => this.viewClaim(),
      },
      {
        label: 'Eliminar audiencia',
        icon: 'pi pi-trash',
        disabled: !this.verificateAudienceDateForDelete(),
        command: () => this.deleteAudience(),
      },
    ];

    if (this.rol === UserRol.ADMINISTRATOR || this.rol === UserRol.CONCILIATOR) {
      items.push({
        label: 'Subir acta',
        icon: 'pi pi-upload',
        command: () => this.createMinute(),
      });
    }

    this.threeOptionsItems = items;
    this.items = [...this.threeOptionsItems];
  }

  async getAudiencesPaginated(): Promise<void> {
    let params = new AudiencePaginationParamsModel(
      this.pagination.actualPage,
      this.pagination.itemsPerPage,
      undefined,
      this.filters
    );
    let result;
    if (this.homeView) {
      result = await this.getPaginationNextAudiencesUseCase.execute(params);
    } else {
      result = await this.getPaginationAudiencesUseCase.execute(params);
    }
    if (result) {
      this.haveResults = true;
      setTimeout(() => {
        this.skeleton = false;
      }, 200);
    }
    if (result instanceof Failure) {
      this.haveResults = false;
      this.skeleton = false;
      return;
    }
    if (this.homeView) {
      this.allAudiences = this.sortByDate(result.response);
    } else {
      this.allAudiences = result.response;
    }
    this.pagination.totalQuantity = result.totalQuantity;
  }

  async getAllAudiencesByIdConciliador(): Promise<void> {
    let params = new AudiencePaginationParamsModel(
      this.pagination.actualPage,
      this.pagination.itemsPerPage,
      this.userId,
      this.filters
    );
    let result = await this.getAllAudiencesByIdConciliadorPagination.execute(
      params
    );
    if (result) {
      this.haveResults = true;
      setTimeout(() => {
        this.skeleton = false;
      }, 200);
    }
    if (result instanceof Failure) {
      this.haveResults = false;
      this.skeleton = false;
      return;
    }
    if (this.homeView) {
      this.allAudiences = this.sortByDate(result.response);
    } else {
      this.allAudiences = result.response;
    }
    this.pagination.totalQuantity = result.totalQuantity;
  }

  createMinute() {
    this.minuteDialogVisible = true;
  }

  handleLoadingChange(loading: boolean) {
    this.isLoadingSpinner = loading;
  }

  cancel(close: any) {
    this.audienciaDialogVisible = false;
    this.minuteDialogVisible = false;
  }

  handleShowMessage(event: {
    severity: string;
    summary: string;
    detail: string;
  }) {
    this.messageService.add({
      severity: event.severity,
      summary: event.summary,
      detail: event.detail,
    });
  }

  refreshGetAll() {
    location.reload();
  }

  async getAudience(): Promise<void> {
    let result = await this.audienceUseCase.execute(this.audienceId!);
    if (result instanceof Failure) {
      return;
    }
    this.audience = result;
  }

  changePage(event: any) {
    this.pagination.actualPage = event.page + 1;
    this.pagination.itemsPerPage = event.rows;
    this.skeleton = true;
    if (this.isConciliatorRol) {
      this.getAllAudiencesByIdConciliador();
    }
    if (
      this.isAdministratorRol ||
      this.isComisionMemberRol ||
      this.isComisionRol
    ) {
      this.getAudiencesPaginated();
    }
  }

  onFiltersApplied(filters: any): void {
    this.pagination.actualPage = 1;
    this.filters = filters;
    if (this.isConciliatorRol) {
      this.filterService.setFilters(filters);
      this.getAllAudiencesByIdConciliador();
    } else {
      this.filterService.setFilters(filters);
      this.getAudiencesPaginated();
    }
  }

  onFilterCancel(): void {
    this.pagination.actualPage = 1;
    this.filters = undefined;
    if (this.isConciliatorRol) {
      this.getAllAudiencesByIdConciliador();
      this.filterService.clear();
    } else {
      this.filterService.clear();
      this.getAudiencesPaginated();
    }
  }

  loadRecords(event: TableLazyLoadEvent) {
    this.getAudiencesPaginated();
  }

  sortByDate(claims: AudienceEntity[]): AudienceEntity[] {
    return claims.sort((a, b) => {
      const dateA = new Date(a.date).getTime();
      const dateB = new Date(b.date).getTime();
      return dateA - dateB;
    });
  }

  selectAmountComisionItems() {
    // For all roles, use the full menu with Subir acta option
    this.items = this.threeOptionsItems;
  }

  public selectAudience(audienceId: string, claim_id: string): void {
    this.claimId = claim_id;
    this.audienceId = audienceId;
    this.selectedAudience = this.allAudiences.find((a) => a.id === audienceId);
    this.buildMenuItems();
  }

  checkHomeView(): void {
    if (this.router.url.includes('/main/home')) {
      this.homeView = true;
    }
  }

  viewClaim() {
    this.router.navigate(['/main/claims', this.selectedAudience?.claimId]);
  }

  deleteAudience(): void {
    this.confirmationService.confirm({
      message: '¿Está seguro que desea eliminar la audiencia?',
      header: '"Eliminar Audiencia"',
      icon: 'pi pi-exclamation-triangle',
      accept: async () => {
        await this.performDeleteAudience();
      },
      reject: () => { },
      acceptLabel: 'Continuar',
      rejectLabel: 'Cancelar',
      acceptButtonStyleClass: 'p-button-primary custom-continue-btn',
      rejectButtonStyleClass: 'p-button-secondary custom-cancel-btn',
    });
  }

  private async performDeleteAudience(): Promise<void> {
    this.isLoading = true;
    let AudienceEntity = new DeleteAudienceModel(this.audienceId!);
    let result = await this.deleteAudienceUseCase.execute(AudienceEntity);
    this.isLoading = false;

    if (result instanceof Failure) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: result.message,
      });
      return;
    }

    this.messageService.add({
      severity: 'success',
      summary: 'Audiencia eliminada',
      detail: 'La audiencia se eliminó exitosamente.',
    });

    if (this.isConciliatorRol) {
      this.getAllAudiencesByIdConciliador();
    } else if (this.isAdministratorRol) {
      this.getAudiencesPaginated();
    }

    setTimeout(() => {
      if (!this.homeView) {
        this.router.navigate(['/main/audiences']);
      }
    }, 1100);
  }

  openMeet() {
    let meetLink = this.selectedAudience?.link_google_meet;

    if (meetLink && !meetLink.startsWith('https://')) {
      meetLink = 'https://' + meetLink;
    }

    if (meetLink) {
      const newWindow = window.open(meetLink, '_blank');

      if (!newWindow) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail:
            'No se pudo abrir el enlace de Google Meet. Asegúrate de que las ventanas emergentes no estén bloqueadas.',
        });
      }
    } else {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'El enlace de Google Meet no está disponible.',
      });
    }
  }
}
